export default {
  'pages.businessAppMarket.title': 'App market',
  'pages.businessAppMarket.subtitle':
    'Discover business apps for your team and activate them as needed.',
  'pages.businessAppMarket.backToCenter': 'Back to Applications',
  'pages.businessAppMarket.myApps': 'My apps',
  'pages.businessAppMarket.refresh': 'Refresh',
  'pages.businessAppMarket.searchLabel': 'App name',
  'pages.businessAppMarket.searchPlaceholder':
    'Search app names or descriptions',
  'pages.businessAppMarket.search': 'Search',
  'pages.businessAppMarket.pricingLabel': 'Pricing',
  'pages.businessAppMarket.all': 'All',
  'pages.businessAppMarket.free': 'Free',
  'pages.businessAppMarket.paid': 'Paid',
  'pages.businessAppMarket.categoryLabel': 'Category',
  'pages.businessAppMarket.allCategories': 'All categories',
  'pages.businessAppMarket.resetFilters': 'Reset filters',
  'pages.businessAppMarket.resultCount': '{count} apps',
  'pages.businessAppMarket.loadError': 'Could not load app market',
  'pages.businessAppMarket.loadErrorDescription':
    'App information is temporarily unavailable. Please try again later.',
  'pages.businessAppMarket.retry': 'Retry',
  'pages.businessAppMarket.empty': 'No apps listed yet',
  'pages.businessAppMarket.filteredEmpty': 'No matching apps',
  'pages.businessAppMarket.emptyDescription':
    'Adjust your filters or check back for newly listed apps.',
  'pages.businessAppMarket.details': 'View details',
  'pages.businessAppMarket.detailTitle': 'App details',
  'pages.businessAppMarket.description': 'About this app',
  'pages.businessAppMarket.developer': 'Developer',
  'pages.businessAppMarket.unknownDeveloper': 'Developer not provided',
  'pages.businessAppMarket.noDescription': 'No description available',
  'pages.businessAppMarket.certification': 'Certification',
  'pages.businessAppMarket.official': 'Officially verified',
  'pages.businessAppMarket.unverified': 'Unverified',
  'pages.businessAppMarket.category': 'Category',
  'pages.businessAppMarket.uncategorized': 'Uncategorized',
  'pages.businessAppMarket.price': 'Price',
  'pages.businessAppMarket.contactRequired': 'Contact support',
  'pages.businessAppMarket.contactReason':
    'Contact the operations team if no sales price is configured, pricing is per seat, or the activation method is unspecified.',
  'pages.businessAppMarket.freeActivate': 'Activate for free',
  'pages.businessAppMarket.paidActivate': 'Purchase and activate',
  'pages.businessAppMarket.open': 'Open app',
  'pages.businessAppMarket.unavailableUrl':
    'No usable access URL is configured',
  'pages.businessAppMarket.installed': 'Activated',
  'pages.businessAppMarket.previewImages': 'App previews',
  'pages.businessAppMarket.previewAlt': '{name} preview {index}',
  'pages.businessAppMarket.noPreview': 'No preview images available',
  'pages.businessAppMarket.close': 'Close',
  'pages.businessAppMarket.missingApp': 'App not found',
  'pages.businessAppMarket.missingAppDescription':
    'This app was not found in the current catalog results. Search its name and try again; it may also have been removed.',
  'pages.businessAppMarket.clearDetails': 'Back to app list',
  'pages.businessAppMarket.detailLoadError': 'Could not load app details',
  'pages.businessAppMarket.detailLoading': 'Loading app details',
  'pages.businessAppMarket.confirmFreeTitle': 'Confirm free activation',
  'pages.businessAppMarket.confirmPaidTitle': 'Confirm purchase',
  'pages.businessAppMarket.confirmFreeDescription':
    'Activate {name} for the current company.',
  'pages.businessAppMarket.confirmPaidDescription':
    'Create a purchase order for {name} for the current company at {price}.',
  'pages.businessAppMarket.confirm': 'Confirm',
  'pages.businessAppMarket.cancel': 'Cancel',
  'pages.businessAppMarket.activateSuccess': 'App activated successfully',
  'pages.businessAppMarket.alreadyActive': 'App is already activated',
  'pages.businessAppMarket.activateError':
    'Could not activate the app. Please try again later.',
  'pages.businessAppMarket.orderError':
    'Could not create the order. Please try again later.',
  'pages.businessAppMarket.confirmationError':
    'Could not confirm activation requirements. Refresh and try again.',
  'pages.businessAppMarket.contextChanged':
    'Your company or sign-in status has changed. Refresh before continuing.',
  'pages.businessAppMarket.sessionRequired':
    'Sign in and select a company to continue.',
};
